"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MLOPS_SIDEBAR_NODES = void 0;
const constants_1 = require("../constants");
const R = constants_1.AI_CONSOLE_ROLES;
const D = constants_1.DOMAIN_ADMIN_ROLES;
/** Sidebar children under catalog `ml` / MLOps (paths, roles, i18n `nav.mlops.*`). */
exports.MLOPS_SIDEBAR_NODES = [
    {
        id: 'mlops-overview',
        menuKey: 'overview',
        msg: 'nav.mlops.overview',
        path: '/llm/ecs/user',
        roles: R,
    },
    {
        id: 'mlops-ai-market',
        type: 'group',
        menuKey: 'aiMarket',
        msg: 'nav.mlops.aiMarket',
        roles: R,
        children: [
            {
                id: 'mlops-compute-market',
                menuKey: 'computeMarket',
                msg: 'nav.mlops.computeMarket',
                path: '/llm/market',
                roles: R,
            },
        ],
    },
    {
        id: 'mlops-train-infer',
        type: 'group',
        menuKey: 'trainAndInference',
        msg: 'nav.mlops.trainAndInference',
        roles: R,
        children: [
            {
                id: 'mlops-container-instance',
                menuKey: 'containerInstance',
                msg: 'nav.mlops.containerInstance',
                path: '/llm/ecs/instances',
                roles: R,
            },
            {
                id: 'mlops-train-task',
                menuKey: 'trainTask',
                msg: 'nav.mlops.trainTask',
                path: '/llm/train/tasks',
                roles: R,
                visibility: ['trainEnabled'],
            },
            {
                id: 'mlops-train-template',
                menuKey: 'trainTemplate',
                msg: 'nav.mlops.trainTemplate',
                path: '/llm/train/templates',
                roles: R,
                visibility: ['trainEnabled'],
            },
            {
                id: 'mlops-inference',
                menuKey: 'inferenceService',
                msg: 'nav.mlops.inferenceService',
                path: '/llm/deploy/deployments',
                roles: R,
                visibility: ['deployEnabled'],
            },
        ],
    },
    {
        id: 'mlops-assets',
        type: 'group',
        menuKey: 'aiAssets',
        msg: 'nav.mlops.aiAssets',
        roles: R,
        children: [
            {
                id: 'mlops-dataset',
                menuKey: 'dataset',
                msg: 'nav.mlops.dataset',
                path: '/llm/ecs/datasets',
                roles: R,
            },
            {
                id: 'mlops-model',
                menuKey: 'modelManage',
                msg: 'nav.mlops.modelManage',
                path: '/llm/ecs/models',
                roles: R,
            },
            {
                id: 'mlops-image',
                menuKey: 'containerImage',
                msg: 'nav.mlops.containerImage',
                path: '/llm/ecs/images',
                roles: R,
            },
            {
                id: 'mlops-repo',
                menuKey: 'repository',
                msg: 'nav.mlops.repository',
                path: '/llm/ecs/repositories',
                roles: R,
            },
            {
                id: 'mlops-disk',
                menuKey: 'diskStorage',
                msg: 'nav.mlops.diskStorage',
                path: '/llm/ecs/disks',
                roles: R,
            },
        ],
    },
    {
        id: 'mlops-resource',
        type: 'group',
        menuKey: 'resourceManage',
        msg: 'nav.mlops.resourceManage',
        roles: D,
        children: [
            {
                id: 'mlops-dedicated-res',
                menuKey: 'dedicatedResource',
                msg: 'nav.mlops.dedicatedResource',
                path: '/llm/ecs/resources',
                roles: D,
            },
            {
                id: 'mlops-quota',
                menuKey: 'resourceQuota',
                msg: 'nav.mlops.resourceQuota',
                path: '/llm/ecs/resource_quotas',
                roles: D,
            },
            {
                id: 'mlops-mon',
                menuKey: 'resourceMonitor',
                msg: 'nav.mlops.resourceMonitor',
                path: '/llm/ecs/resource_monitor',
                roles: D,
            },
            {
                id: 'mlops-audit',
                menuKey: 'resourceAudit',
                msg: 'nav.mlops.resourceAudit',
                path: '/llm/ecs/audit_logs',
                roles: D,
            },
        ],
    },
    {
        id: 'mlops-system',
        type: 'group',
        menuKey: 'systemSetting',
        msg: 'nav.mlops.systemSetting',
        visibility: ['adminMode'],
        children: [
            {
                id: 'mlops-gpu-dash',
                menuKey: 'resourceDashboard',
                msg: 'nav.mlops.resourceDashboard',
                icon: 'menu-dashboard',
                path: '/llm/ecs/gpu_dashboard',
                adminOnly: true,
            },
            {
                id: 'mlops-compute-cluster',
                menuKey: 'computeCluster',
                msg: 'nav.mlops.computeCluster',
                path: '/llm/ecs/clusters',
                adminRoleOnly: true,
            },
            {
                id: 'mlops-storage-cluster',
                menuKey: 'storageCluster',
                msg: 'nav.mlops.storageCluster',
                path: '/llm/ecs/storage_clusters',
                adminRoleOnly: true,
            },
        ],
    },
];
